// // ActualizarCambioServicePage.tsx

// import { useCheckPermissions } from "@/shared";
import { SaveCambioService } from "../../components";
import { Navigate, useParams } from "react-router-dom";
import { useFetchGetCambioParaEdicion } from "@/shared/actions/controlcambios/cambio-service.actions";
import { LoaderComponent } from "@/shared/components/ui";
// useFetchGetByIdCambioService,
export default function UpdateCambioServicePage() {

//   useCheckPermissions(PermissionsEnum.api_change_cambioservice);

  const { id } = useParams();

  const {
    data,
    isLoading,
    isRefetching
  } = useFetchGetCambioParaEdicion(id!);

  if (
    isLoading ||
    isRefetching
  ) return <LoaderComponent />;

  if (!data) 
    return <Navigate to={'/'} />;

  return (
    <SaveCambioService
      titulo="Actualizar control de cambios"
      data={data}
      idCambio={id}
    />
  )
}
